import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/** Starts deletion of the document held by the confirmation state. */
export const confirmDelete = store.effects.create((feature: Feature) =>
  feature.actions.confirmDeletion.observe().pipe(
    rxjs.withLatestFrom(
      feature.selectors.deletingFile.asObservable,
      feature.selectors.isDeleting.asObservable,
    ),
    rxjs.mergeMap(([action, file, deleting]) =>
      file && !deleting
        ? rxjs.of(feature.actions.delete.request.from(action).create(file))
        : rxjs.EMPTY,
    ),
  ),
)
